import ResponsiveEmbed from "react-responsive-embed";
import * as React from 'react';
export default {
  ResponsiveEmbed,
  React
};